class CustomTabs extends HTMLElement {
  constructor() {
    super();
    let tabButtons = this.querySelectorAll('[data-tab-button]');
    let tabContents = this.querySelectorAll('[data-tab-content]');
    tabButtons.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabButtons.forEach(function (btn) {
          btn.classList.remove('btn--active');
        });
        tab.classList.add('btn--active');
        let tabBtnTitle = tab.getAttribute('data-tab-button');
        tabContents.forEach(function (content) {
          content.classList.remove('promotion__tabs-item--active');
        });
        tabContents.forEach(function (content) {
          let tabContentTitle = content.getAttribute('data-tab-content');
          if (tabContentTitle === tabBtnTitle) {
            content.classList.add('promotion__tabs-item--active');
          }
        });
      });
    });
  }
}

customElements.define('custom-tabs', CustomTabs);